export default {
  anim: process.env.VUE_APP_ANIMATION == 'true',  //是否开启动画
};